export const GET_STORE_COMPLETE_DETAIL = {
    INIT: "GET_STORE_COMPLETE_DETAIL_INIT",
    SUCCESS: "GET_STORE_COMPLETE_DETAIL_SUCCESS",
    ERROR: "GET_STORE_COMPLETE_DETAIL_ERROR"
}